export default __webpack_public_path__ + "static/media/bannerNosotros.d42bb2f7.webp";